import { render, staticRenderFns } from "./InaccessibleNexultra1And2InformModal.vue?vue&type=template&id=6036e26c&scoped=true"
import script from "./InaccessibleNexultra1And2InformModal.vue?vue&type=script&lang=js"
export * from "./InaccessibleNexultra1And2InformModal.vue?vue&type=script&lang=js"
import style0 from "./InaccessibleNexultra1And2InformModal.vue?vue&type=style&index=0&id=6036e26c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6036e26c",
  null
  
)

export default component.exports